<template>
    <div id="body-wrap" class="">
        <LayoutHeader />
        <Openapi />
        <Footer />
        <FooterPc />
        <Common />
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Openapi from '@/views/openapi/Openapi.vue';
import Common from '@/views/common/Common.vue';

import { mapGetters } from 'vuex';
import { defualtMeta } from '@/confs/vue.meta';

export default {
    metaInfo: {
        meta: defualtMeta,
    },
    components: {
        LayoutHeader,
        Footer,
        FooterPc,
        Openapi,
        Common,
    },
    computed: {
        ...mapGetters({
        }),
    },
    created() {
        Promise.all(
            [this.$store.dispatch('FETCH_DATASRC_CATE_LIST'), 
            this.$store.dispatch('FETCH_OPENAPI_ENDPOINT_MAP'),
            this.$store.dispatch('FETCH_OPENAPI_GRID_DATA')]
        ).then(()=>{
            this.$store.dispatch('FETCH_DATASRC_LIST');
            this.$store.dispatch("FETCH_ERROR_REPORT");
        });
    },
    methods: {
    },
};
</script>
